import React from "react";
import { useState,useEffect } from "react";
import { Helmet } from 'react-helmet';
import ScoutSidebar from "./ScoutSidebar";
import './classes/ScoutRequestReportView.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const ScoutRequestReportView = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({});

      const location = useLocation();
        const drupal_uid = localStorage.getItem('drupal_uid');
        const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
        var loggedin_domain = drupal_domain_url;
        if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
        } 
        const {sid} = useParams();
        
       const app_url = configData.APP_URL;
        
    useEffect(() => {
            Promise.all([
                getscoutrequestview()
            ])
            .then(() => {
            
                setIsLoading(false);
            })
            
        },[]);
  // All data 
  const submissionData = {
    formName: "Scouting Requests",
    submittedBy: "Anonymous (not verified)",
    submittedDate: "Fri, 2025-06-06 06:00",
    ipAddress: "103.103.237.252",
    player: {
      "report-individual": { label: "Player's First Name", data: "TestMintu" },
      "players-last-name": { label: "Player's Last Name", data: "Kittu" },
      "players-age": { label: "Player's Age", data: "22" },
      "sport-played": { label: "Player's Sport", data: "Football (American)" },
      "currently-playing-for": { label: "Team Which the Player is On", data: "TEST" },
      "position-played": { label: "Player's Position", data: "BB" },
      "players-country": { label: "Where to Scout the Player", data: "United States" },
      "players-state": { label: "Player's State", data: "Oregon" },
      "players-ranking-website": { label: "Link to a Website(s) That Shows the Player's Ranking", data: "" },
      "players-video-link": { label: "Links to Any Highlight Videos", data: "" },
    },
    requester: {
      "first-name": { label: "First Name", data: "TestPatel" },
      "last-name": { label: "Last Name", data: "Raotest" },
      "email": { label: "Email", data: "raopateltest@preferati.com" },
      "phone": { label: "Phone Number", data: "5036984758" },
      "street-address": { label: "Street Address", data: "Portland" },
      "relationship-with-player": { label: "Relationship with Player", data: "SMWW Agent Advisor" },
      "are-you-an-smww-agent-advisor": { label: "Are You an SMWW Agent Advisor", data: "Yes" },
      "notes": { label: "Notes", data: "" },
    },
    userId: "881569",
  };

  const {
    formName,
    submittedBy,
    submittedDate,
    ipAddress,
    player,
    requester,
    userId,
  } = data;
async function getscoutrequestview() {
        const response = await fetch(
          app_url+'smwwscout/getscoutrequestview?sid='+sid,
          {
            method: "GET",
      
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )           
        const responsedata = await response.json();
          if(responsedata.data.msg === "Success") {
          setData(responsedata.data.result);
     
          }
           
        }
  return (
     <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
                  <Helmet>
                      <title>Submission #874</title>
                  </Helmet>
            <div className="left"></div>
            <div className="center left-center">
              <div className="scout-report-view-container">
     {/* Top Navigation */}
<nav>
  <a href="#">Previous submission</a>
  <a href="#">Next submission</a>
</nav>

{/* Submission Info */}
<fieldset>
  <legend>Submission information</legend>
  <div>
    <div>Form: <a href="#">{formName}</a></div>
    <div>Submitted by <span>{submittedBy}</span></div>
    <div>{submittedDate}</div>
    <div>{ipAddress}</div>
  </div>
</fieldset>

{/* Player Info */}
<h2>Player Information</h2>
{Object.entries(player).map(([key, value]) => (
  <div key={key} className="form-item">
    <label>{value.label}</label>
    <span>{value.data || <em>—</em>}</span>
  </div>
))}

{/* Requester Info */}
<h2>Requester Information</h2>
{Object.entries(requester).map(([key, value]) => (
  <div key={key} className="form-item">
    <label>{value.label}</label>
    <span>{value.data || <em>—</em>}</span>
  </div>
))}
{/* User ID */}
<div className="form-item">
  <label>User ID</label>
  <span>{userId || <em>—</em>}</span>
</div>

{/* Bottom Navigation */}
<nav>
  <a href="#">Previous submission</a>
  <a href="#">Next submission</a>
</nav>
</div>
    </div>

 
            <div className="right">
                <ScoutSidebar/>
            </div>
        </div>
            )}
            </>
    );
};

export default ScoutRequestReportView;
